mutation PurchaseOrderRevisionUpdate(
  $input: PurchaseOrderRevisionUpdateInput!
) {
  purchaseOrderRevisionUpdate(input: $input) {
    entityDocument {
      id
    }
  }
}
